import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

interface SsoClientOption {
  SsoClientId: number;
  LogoUrl: string;
  DisplayName: string;
  Description: string;
  ChallengeUrl: string;
  SupportLink: string;
}

@Component({
  selector: 'ez-sso-options',
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './sso-options.component.html',
  styleUrls: ['./sso-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsoOptionsComponent implements OnInit {
  selectedSsoClientId: number | null = null;
  ssoClientOptions: SsoClientOption[] = [];

  readonly #elementRef = inject(ElementRef);

  ngOnInit(): void {
    const getAttribute = this.#elementRef.nativeElement.getAttribute.bind(this.#elementRef.nativeElement);

    const attribute = getAttribute('sso-client-options');
    this.ssoClientOptions = JSON.parse(attribute) as SsoClientOption[];
  }

  back(): void {
    window.location.href = '/auth/account/login';
  }
}
